import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Config from '../../utils/config.service';

@Component({
	standalone: true,
	selector: 'modal-chat-download',
	templateUrl: './modal-chat-download.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalChatDownloadComponent implements OnInit {
	private config: Config = inject(Config);
	private dialogRef = inject(MatDialogRef<ModalChatDownloadComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.downoadLink1 = this.config.getRestUrl() + 'rest/chat/' + this.vm.chat.id + '/download?withTimes=true';
		this.vm.downoadLink2 = this.config.getRestUrl() + 'rest/chat/' + this.vm.chat.id + '/download';
		
		this.vm.close = this.close;
	}
	
	close() {
		this.dialogRef.close();
	}
	
}